import React from 'react';
import SEO from '../components/SEO';

const ThankYou = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#0a0a0a] to-[#000000] flex items-center justify-center px-4 py-20">
      <SEO 
        title="Thank You | White House Publishers"
        description="Thank you for choosing White House Publishers"
        url="/thank-you"
      />
      
      <div className="max-w-4xl mx-auto text-center">
        <div className="mb-8">
          {/* Logo */}
          <div className="mb-8">
            <img 
              src="https://customer-assets.emergentagent.com/job_publishhub/artifacts/l6f2vg6h_logo-02.png"
              alt="White House Publishers"
              className="h-16 sm:h-20 mx-auto"
            />
          </div>
          
          <div className="w-32 h-32 mx-auto mb-6 bg-gradient-to-br from-[#F4D03F] to-[#F8D26B] rounded-full flex items-center justify-center">
            <svg className="w-20 h-20 text-[#0a0a0a]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-[#F4D03F] mb-6">
            🎉 Your Publishing Journey Begins Now! 🎉
          </h1>
          
          <p className="text-xl sm:text-2xl text-gray-300 mb-4">
            Thank you for choosing White House Publishers
          </p>
          
          <p className="text-lg text-gray-400 max-w-2xl mx-auto mb-8">
            We've received your request and our expert team is already reviewing your details to provide you with the best publishing solution.
          </p>
        </div>

        <div className="grid sm:grid-cols-3 gap-6 mb-12">
          <div className="bg-[#302f2c] border-2 border-[#F4D03F]/30 rounded-xl p-6">
            <div className="text-3xl font-bold text-[#F4D03F] mb-2">24 Hours</div>
            <div className="text-sm text-gray-400">Response Time</div>
          </div>
          <div className="bg-[#302f2c] border-2 border-[#F4D03F]/30 rounded-xl p-6">
            <div className="text-3xl font-bold text-[#F4D03F] mb-2">500+</div>
            <div className="text-sm text-gray-400">Authors Published</div>
          </div>
          <div className="bg-[#302f2c] border-2 border-[#F4D03F]/30 rounded-xl p-6">
            <div className="text-3xl font-bold text-[#F4D03F] mb-2">15+ Years</div>
            <div className="text-sm text-gray-400">Industry Experience</div>
          </div>
        </div>

        <div className="bg-[#302f2c] border-2 border-[#F4D03F] rounded-2xl p-8 mb-8">
          <h2 className="text-3xl font-bold text-[#F4D03F] mb-6">What Happens Next?</h2>
          <p className="text-gray-300 mb-4">
            Our publishing experts will review your submission and contact you <span className="text-[#F4D03F] font-bold">within the next 24 hours</span> to discuss your project in detail.
          </p>
          <p className="text-gray-400">
            Please check your email (and spam folder) for our confirmation message.
          </p>
        </div>

        <a 
          href="/" 
          className="inline-block bg-[#F4D03F] hover:bg-[#F8D26B] text-[#0a0a0a] font-bold py-3 px-8 rounded-lg transition-colors"
        >
          Return to Homepage
        </a>
      </div>
    </div>
  );
};

export default ThankYou;
